import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgCheckCircleIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M32 9.6C19.63 9.6 9.6 19.629 9.6 32S19.63 54.4 32 54.4c12.372 0 22.4-10.029 22.4-22.4S44.372 9.6 32 9.6M6.4 32C6.4 17.862 17.862 6.4 32 6.4S57.6 17.862 57.6 32 46.14 57.6 32 57.6C17.862 57.6 6.4 46.139 6.4 32m36.56-7.958-9.93 16.042a3.2 3.2 0 0 1-2.72 1.516h-2.327a3.2 3.2 0 0 1-2.526-1.236l-5.12-6.582 2.526-1.964 5.12 6.582h2.326l9.931-16.042z"
    />
  </svg>
)
export default SvgCheckCircleIcon
